function Stripe({ dimensions, col = '#000' }) {
    const baseXml = `
      <svg width=${dimensions || '24'} height=${dimensions || '24'} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.976 9.15c-2.172-.806-3.356-1.426-3.356-2.409 0-.831.763-1.444 1.996-1.444 1.986 0 4.073.935 4.073.935l.833-3.033s-1.847-1.112-4.906-1.112C10.033 2.087 7.74 3.791 7.74 6.784c0 4.292 3.868 5.717 6.012 6.551 1.996.776 2.768 1.406 2.768 2.328 0 1.053-1.032 1.63-2.452 1.63-2.433 0-5.124-1.295-5.124-1.295l-1.003 3.033s2.173 1.882 6.126 1.882c2.81 0 5.467-1.468 5.467-4.661.001-4.148-3.559-5.301-5.558-6.102z" fill=${`"${col}"`}/>
      </svg>
    `;

    return baseXml;
}

export default Stripe;
